/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/basic-info.css";
import { Button, Segment, Form, Header, Progress, Select, Image } from "semantic-ui-react";
import { Link, Redirect } from "react-router-dom";
import API from "../utility/API";
import ProgressBar from "../components/progress-bar";
import { Input, FreeForm, FormRow, Dropdown } from "kx-common-components";
import axios from "axios";
import Upload from "../media/upload.svg";
import { get } from "lodash";

class BasicInfo extends Component {
  constructor() {
    super();
    this.state = {
      toNextPage: false,
      progress: 11.1,
      email: "",
      companyName:"",
      fullName:"",
      password: "",
      confirmPassword: "",
      additionalEmail: "",
      phoneType: "",
      phoneNumber: "",
      error: false
    };
  }

  passwordError = () => {
    this.setState({ error: true }, () => {
      document.getElementById("pwError").innerHTML = "<br /><center> Passwords do not match. </center>";
    });
  };
  passwordLengthError=()=>{
    this.setState({ error: true }, () => {
      document.getElementById("pwError").innerHTML = "<br /><center> The minimum length for a password is 8 characters. </center>";
    });
  }

  passwordMatch = () => {
    const { password, confirmPassword } = this.state;
    return password === confirmPassword;
  };
  

  formatPhone = (str) => {
    return str.replace(/\D/g, "");
  };

  handleUpdate(key, e) {
    this.setState({ [key]: e, error: false });
  }

  handleSubmit = () => {
    const { sessionData } = this.props;
    const { password, image, phoneNumber, match, companyName,  fullName} = this.state;
    if(password.length>=8){
      if (this.passwordMatch()) {
        API.updateProfile(sessionData.tempToken, companyName, sessionData.email, fullName, password, this.formatPhone(phoneNumber))
          .then((response) => {
            return response.json();
          })
          .then((responseData) => {
            let token = responseData.eventMessage.user.kxCustomerToken;
            var dt = new Date();
            dt.setTime(dt.getTime() + 2 * 24 * 60 * 60 * 1000);
            document.cookie = "kxCustomerToken=" + token + ";expires=" + dt.toUTCString() + ";domain=klearexpress.com";
          })
          .then(this.setState({ toNextPage: true }))
          .catch((err) => console.log("ERROR:", err));
      } else {
        this.passwordError();
      }
    }else{
      this.passwordLengthError();
    }
    
  };

  render() {
    const { sessionData, storeProgressData } = this.props;
    const { fullname, email, password, additionalEmail, phoneNumber, confirmPassword, toNextPage, error } = this.state;
    console.log("state: ", this.state);
    if (toNextPage === true) {
      storeProgressData("basicInfo", "piece progress-green");
      return <Redirect to="/finish" />;
    }

    return (
      <Segment padded="very" className="basic-info-segment" raised>
        <div className="login-header">Personal Information</div>
        <div className="basic-info-content">
          <FreeForm>
            <FormRow>
              <Input  onChange={(e) => this.handleUpdate("companyName", e)} label={"COMPANY NAME"} singleElement topElement />
            </FormRow>
            <FormRow>
              <Input  onChange={(e) => this.handleUpdate("fullName", e)} label={"FULL NAME"} singleElement />
            </FormRow>
            <FormRow>
              <Input value={sessionData.email} onChange={(e) => this.handleUpdate("email", e)} label={"EMAIL"} singleElement />
            </FormRow>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("phoneNumber", e)} label={"PHONE NUMBER"} singleElement bottomElement />
            </FormRow>
          </FreeForm>
          <br />
          <br />
          <FreeForm>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("password", e)} label={"PASSWORD"} singleElement topElement password />
            </FormRow>
            <FormRow>
              <Input onChange={(e) => this.handleUpdate("confirmPassword", e)} label={"CONFIRM PASSWORD"} singleElement bottomElement password />
            </FormRow>
          </FreeForm>
          {error && <span id={"pwError"}></span>}
          <br />
          <br />
          <div className={"button-row"}>
            <Button className="hollow-button cancel-button">CANCEL</Button>
            <Button className="solid-button" onClick={() => this.handleSubmit()}>
              NEXT
            </Button>
          </div>
        </div>
      </Segment>
    );
  }
}

export default BasicInfo;
